<template>
    <el-dialog class="setName" title="机构名称" :close-on-click-modal="false" :visible.sync="dialogVisible" width="600" :before-close="handleClose">
        <div class="inputBox">
            <div class="name">机构名称</div>
            <el-input v-model="name" autocomplete="off" maxlength="10" show-word-limit></el-input>
        </div>
        <div class="btnBox">
            <el-button @click="handleClose">取消</el-button>
            <el-button type="primary" @click="handleAffirm">确定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import {uploadShopName} from 'api/accountApi'
import {mapActions} from 'vuex'
export default {
    data() {
        return {
            dialogVisible: false,
            name: ''
        }
    },
    props: ['data'],
    methods: {
        open () {
            this.dialogVisible = true
        },
        handleClose() {
            this.dialogVisible = false
        },
        handleAffirm() {
            if (this.name) {
                this.setLoading(true)
                let options = {
                    hostname: this.name
                }
                uploadShopName({
                    data: options,
                    success: res => {
                        this.setLoading(false)
                        this.dialogVisible = false
                        this.$emit('setName', this.name)
                    },
                    error: res => {
                        this.setLoading(false)
                        this.$message.error(res.msg)
                    }
                })
            } else {
                this.$message.error('请输入机构名称')
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    watch: {
        'data': {
            handler(newV, oldV) {
                if (newV.hostname) {
                    this.name = newV.hostname
                }
            },
            deep: true
        }
    }
}
</script>
<style lang="scss">
    .setName {
        .el-dialog__body {
            .inputBox {
                display: flex;
                align-items: center;
                justify-content: center;
                .name {
                    width: 56px;
                    margin-right: 40px;
                    font-size: 14px;
                }
                .el-input {
                    width: 400px;
                }
            }
            .btnBox {
                display: flex;
                align-items: center;
                justify-content: center;
                padding-top: 40px;
            }
        }
    }
</style>